module.exports = __webpack_public_path__ + "img/nyc-two.5a35a5de.jpg";